import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useGoBack } from '@libs/hooks/useGoBack';

import { ClockControlType } from '@features/shared/api/typings';
import { PlayerProfilePageWidget } from '@features/user/pages/PlayerProfilePage/PlayerProfilePageWidget';

export const Route = createFileRoute('/profile/stats/$clockControl')({
  component: RouteComponent,
});

function RouteComponent() {
  const { clockControl } = Route.useParams();
  const navigate = useNavigate();
  const setIsClubsAndTournamentsOpen = useCallback(
    (isOpen: boolean) => {
      if (isOpen) {
        navigate({
          to: '/profile/clubs-and-tournaments',
          from: '/',
        });
      }
    },
    [navigate],
  );

  const goBackRoot = useGoBack({
    to: '/profile',
    from: '/',
    replace: true,
  });
  const setIsEloStatsModalOpen = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) {
        goBackRoot();
      }
    },
    [goBackRoot],
  );

  const goBackStats = useGoBack({
    to: `/profile/stats`,
    from: '/',
    replace: true,
  });
  const setOpenFullGamesList = useCallback(
    (clockControlType?: ClockControlType) => {
      if (!clockControlType) {
        goBackStats();
      }
    },
    [goBackStats],
  );

  const clockControlType = (clockControl.charAt(0).toUpperCase() +
    clockControl.slice(1)) as ClockControlType;

  return (
    <PlayerProfilePageWidget
      isEloStatsModalOpen
      setIsEloStatsModalOpen={setIsEloStatsModalOpen}
      isClubsAndTournamentsOpen={false}
      setIsClubsAndTournamentsOpen={setIsClubsAndTournamentsOpen}
      openFullGamesListClockControlType={clockControlType}
      setOpenFullGamesList={setOpenFullGamesList}
    />
  );
}
